import { fontSize } from '../../..';
import AddCustomValue from './AddCustomValue';

interface FlowInfoProps {
  propKey: string;
  flowname: string;
  min: number;
  max: number;
  currentValue: number;
  onAddCustomValue: (type: 'parameter' | 'static', datatype?: string) => void;
}
function FlowInfo({ propKey, flowname, min, max, currentValue, onAddCustomValue }: FlowInfoProps) {
  const rangeText =
    min === max ? `${currentValue} of ${min}` : `${currentValue} of ${min} to ${max}`;
  return (
    <div
      style={{
        fontWeight: 'bold',
        textAlign: 'start',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <section style={{ display: 'flex', gap: '5px' }}>
        <span
          style={{
            fontSize: fontSize.large,
            paddingLeft: '10px',
            color: '#484848',
          }}
        >
          {flowname}
        </span>
        <span
          style={{
            textAlign: 'center',
            fontSize: '11px',
            color: '#999999',
            paddingTop: '3px',
          }}
        >
          {rangeText}
        </span>
      </section>
      <AddCustomValue
        propKey={propKey}
        disabled={true}
        tooltip={'Add Custom Value'}
        onClick={onAddCustomValue}
        enabledOptions={['integer', 'decimal']}
      />
    </div>
  );
}

export default FlowInfo;
